import { initial } from 'react-beep';
import storage from 'providers/storage';

initial([
  {
    name: 'token',
    defaultValue: storage.get('token'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('token');
        return;
      }
      storage.set('token', value);
    },
  },
  {
    name: 'profile',
    defaultValue: storage.get('profile'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('profile');
        return;
      }
      storage.set('profile', value);
    },
  },
  {
    name: 'detail',
    defaultValue: storage.get('detail'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('detail');
        return;
      }
      storage.set('detail', value);
    },
  },
  {
    name: 'path',
    defaultValue: storage.get('path'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('path');
        return;
      }
      storage.set('path', value);
    },
  },
  {
    name: 'reminder',
    defaultValue: storage.get('reminder'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('reminder');
        return;
      }
      storage.set('reminder', value);
    },
  },
  {
    name: 'insurance',
    defaultValue: storage.get('insurance'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('insurance');
        return;
      }
      storage.set('insurance', value);
    },
  },
  {
    name: 'userProfile',
    defaultValue: storage.get('userProfile'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('userProfile');
        return;
      }
      storage.set('userProfile', value);
    },
  },
  {
    name: 'basketImage',
    defaultValue: storage.get('basketImage'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('basketImage');
        return;
      }
      storage.set('basketImage', value);
    },
  },
  {
    name: 'addressUser',
    defaultValue: storage.get('addressUser'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('addressUser');
        return;
      }
      storage.set('addressUser', value);
    },
  },
  {
    name: 'carInfo',
    defaultValue: storage.get('carInfo'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('carInfo');
        return;
      }
      storage.set('carInfo', value);
    },
  },
  {
    name: 'insInfo',
    defaultValue: storage.get('insInfo'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('insInfo');
        return;
      }
      storage.set('insInfo', value);
    },
  },
  {
    name: 'installmentList',
    defaultValue: storage.get('installmentList'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('installmentList');
        return;
      }
      storage.set('installmentList', value);
    },
  },
  {
    name: 'basketId',
    defaultValue: storage.get('basketId'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('basketId');
        return;
      }
      storage.set('basketId', value);
    },
  },
  {
    name: 'postAddress',
    defaultValue: storage.get('postAddress'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('postAddress');
        return;
      }
      storage.set('postAddress', value);
    },
  },
  {
    name: 'priceValue',
    defaultValue: storage.get('priceValue'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('priceValue');
        return;
      }
      storage.set('priceValue', value);
    },
  },
  {
    name: 'deliveryTime',
    defaultValue: storage.get('deliveryTime'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('deliveryTime');
        return;
      }
      storage.set('deliveryTime', value);
    },
  },
  {
    name: 'addressAttach',
    defaultValue: storage.get('addressAttach'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('addressAttach');
        return;
      }
      storage.set('addressAttach', value);
    },
  },
  {
    name: 'bankList',
    defaultValue: storage.get('bankList'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('bankList');
        return;
      }
      storage.set('bankList', value);
    },
  },
  {
    name: 'isTimer',
    defaultValue: storage.get('isTimer'),
    didUpdate: (value) => {
      if (value === null) {
        storage.remove('isTimer');
        return;
      }
      storage.set('isTimer', value);
    },
  },

  {
    name: 'snackbarOpen',
    defaultValue: false,
  },

  {
    name: 'snackbarType',
    defaultValue: '',
  },
  {
    name: 'snackbarText',
    defaultValue: '',
  },
]);
